<template>
  <div class="ani-stage">
    <template v-if="prepared">
      <div class="ani-stage-inner">
        <!-- slot header -->
        <slot name="header"/>

        <template v-for="(it, idx) in items">
          <ani-stage-card
            :vw-size="VWSize"
            :idx="idx"
            :pending="currentIndex < idx"
            :active="currentIndex === idx"
            :ref="`ref-card-${idx}`"
            :support-animation="supportAnimation"
          >
            <template v-slot:default="{ state }">
              <slot
                name="card"
                :it="it"
                :idx="idx"
                :card-state="state"
                :vw-size="VWSize"
                :support-animation="supportAnimation"
              />
            </template>
          </ani-stage-card>
        </template>

        <!-- progress -->
        <template v-if="hasProgress">
          <ani-stage-progress
            :total="totalItems"
            :current="settledIndex"
            @click.native="_onProgressClick"
          />
        </template>

        <!-- slot tailer -->
        <slot name="tailer"/>
      </div>
    </template>
  </div>
</template>

<script>
  import Vue from 'vue'
  import AniStageCard from './AniCard.vue'
  import AniStageProgress from './AniProgress.vue'
  import zenscroll from 'zenscroll'
  import { isProd } from '@/helpers'

  const EVENT_SCROLL_TO_VW = 'scroll-to-vw'
  const EVENT_ERR = 'ani-stage-err'

  export default {
    name: 'AniStage',

    props: {
      scrollContainer: {
        type: String || HTMLElement,
        required: false
      },

      items: {
        type: Array,
        required: true
      },

      hasProgress: {
        type: Boolean,
        default: true
      },

      supportAnimation: {
        type: Boolean,
        default: true
      }
    },

    data () {
      return {
        locked: false,
        VWSize: null,
        prepared: false,
        error: null,
        currentIndex: -1,
        settledIndex: 0,
      }
    },

    created () {
      this.$watch('prepared', (a) => {
        if (a && !this.error) {
          this.start()
        }
      })
    },

    async mounted () {
      try {
        await this._resolveFullViewportSize()

        // HOOKS
        const scrollContainer = typeof this.scrollContainer === 'string' ?
          document.querySelector(this.scrollContainer) : this.scrollContainer
        const scroller = zenscroll.createScroller(scrollContainer)

        // plugin global
        Vue.prototype.__appZenScroller__ = scroller

        this.$on(EVENT_SCROLL_TO_VW, (el) => {
          if (el && scrollContainer) {
            // TODO: refactor optimize
            const rect = el.getBoundingClientRect()
            const toY = rect.top + scrollContainer.scrollTop - 35

            if (this.supportAnimation) {
              setTimeout(() => {
                // const top = rect.top + scrollContainer.scrollTop - 10
                // scrollContainer.scrollTo({
                //   top: rect.top + scrollContainer.scrollTop - 10,
                //   left: 0,
                //   behavior: 'smooth'
                // })
                // scroller.to(el, 600)
                scroller.toY(toY, 600)
              }, 1500)
            } else {
              scroller.toY(toY, 500)
            }
          }
        })
      } catch (e) {
        console.error(e)
        this.error = e.message
      } finally {
        this.prepared = true
      }
    },

    methods: {
      async _resolveFullViewportSize () {
        const mask = document.createElement('div')
        mask.classList.add('ani-stage-detect-viewport-size')
        this.$el.appendChild(mask)

        this.VWSize = toJSON(mask.getBoundingClientRect())
        this.$el.removeChild(mask)

        return

        // fix low chrome version
        function toJSON (rect) {
          const keys = Object.keys({
            x: 0,
            y: 0,
            width: 375,
            height: 812,
            top: 0,
            right: 375,
            bottom: 812,
            left: 0
          })

          return keys.reduce((acc, it) => {
            acc[it] = rect[it]
            return acc
          }, {})
        }
      },

      _goCard (index) {
        this.currentIndex = index
        this.locked = true

        this.$nextTick(() => {
          this.$emit(EVENT_SCROLL_TO_VW,
            this.activeCardComponent.$el
          )
        })

        // TODO: ---
        setTimeout(() => {
          this.locked = false
        }, 500)
      },

      nextCard (toIdx = 0) {
        if (this.locked) {
          return
        }

        const total = this.items.length
        toIdx = toIdx || this.currentIndex + 1

        // TODO: handle leave card

        if (toIdx >= total) {
          this.$emit(EVENT_ERR, 'NO_MORE')
          throw new Error('NO_MORE')
        }

        this._goCard(toIdx)
      },

      start () {
        if (this.currentIndex > -1) {
          return
        }

        this.nextCard()
      },

      releaseLockedScreen () {
        if (this.locked) {
          this.locked = false
        }
      },

      _playNext () {
        this.nextCard()
      },

      settledProgressNo () {
        this.settledIndex = this.currentIndex + 1
      },

      _onProgressClick () {
        if (!isProd) {
          this.$router.push('/')
          return
        }
      }
    },

    computed: {
      activeCardComponent () {
        if (this.currentIndex < 0) {
          return null
        }

        return this.$refs[`ref-card-${this.currentIndex}`][0]
      },

      totalItems () {
        return this.items && this.items.length
      }
    },

    components: {
      AniStageCard,
      AniStageProgress
    }
  }
</script>
